'use client';

import dynamic from 'next/dynamic';

//* Style
import IndustryIndividualTemplateStyle from './style';

//* Components
import { Container } from '@weareconceptstudio/core';
// const GlobalHeroSection = dynamic(() => import('@/sections/GlobalHeroSection'), {
// 	ssr: true,
// });

import GlobalHeroSection from '@/sections/GlobalHeroSection';

const KeyNumbersSection = dynamic(() => import('../components/KeyNumbersSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const EnvironmentSection = dynamic(() => import('@/modules/DiscoverArmenia/LivingInArmenia/components/EnvironmentSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const ModernLifeSection = dynamic(() => import('@/sections/ModernLifeSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const FAQSection = dynamic(() => import('@/sections/FAQSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const Subscribe = dynamic(() => import('@/sections/Subscribe'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '20vh' }} />,
});
// const TestimonialsSection = dynamic(() => import('@/sections/TestimonialsSection'));
const VideoSection = dynamic(() => import('@/sections/VideoSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const PublicationsGlobalSection = dynamic(() => import('@/sections/PublicationsGlobalSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});

const IndustryIndividualTemplate = ({ pageData }) => {
	const { hero, key_numbers, why_invest, promising_areas, trustedByLeaders, faqs, publications, video } = pageData;

	return (
		<IndustryIndividualTemplateStyle className={`${key_numbers?.items?.length > 0 ? 'key-numbers-variant' : ''}`}>
			<GlobalHeroSection {...hero} />

			<KeyNumbersSection data={key_numbers?.items} />

			<EnvironmentSection
				title={why_invest.title}
				items={why_invest.items}
			/>

			<VideoSection video={video} />

			<ModernLifeSection
				isIndustryIndividual
				title={'promisingAreas'}
				items={promising_areas.items}
			/>

			{/* <TestimonialsSection data={trustedByLeaders} /> */}

			<FAQSection items={faqs} />

			<Container>
				<Subscribe />

				<PublicationsGlobalSection
					isPublicationGridVersion
					publicationsTitle={'publications'}
					publications={publications}
				/>
			</Container>
		</IndustryIndividualTemplateStyle>
	);
};

export default IndustryIndividualTemplate;
